exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/app/angular-base-ui/form-select/form-select.component.scss
// module id = ../../../../../src/app/angular-base-ui/form-select/form-select.component.scss
// module chunks = 1